<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-24 18:32:57
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-08 10:58:53
-->
<template>
	<div class="data-view">
		<div :class="['item', item.isClick ? 'click' : '']" v-for="(item, index) in filterArr" :key="index" @click="skip(item)">
			<div class="num">
				<span class="flag">{{ item.price_icon || '' }}</span>
				<span>{{ item.number }}</span>
			</div>
			<div class="text">
				<span>{{ item.label }}</span>
				<el-tooltip :content="item.desc" v-if="item.desc">
					<i class="iconfont icon-a-help-circle-obangzhu-xian ml-4"></i>
				</el-tooltip>
				<i class="el-icon-arrow-right" v-if="item.isClick"></i>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
	name: 'dataView',
	props: {
		panelData: {
			type: Array,
			default: _ => [],
		},
		params: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		...mapState(['vuex_userInfo']),
		...mapGetters(['isAllDataView', 'isDrPartnerDataView', 'isShopPartnerDataView']),
		filterArr() {
			const { isAllDataView, isDrPartnerDataView, isShopPartnerDataView, panelData } = this;
			let newArr = [];
			if (isAllDataView || isDrPartnerDataView) {
				newArr = panelData.filter(item => item.type == 'all' || item.type == 'administrator_talent');
			}
			if (isShopPartnerDataView) {
				newArr = panelData.filter(item => item.type == 'all' || item.type == 'zs');
			}
			return newArr;
		},
	},
	methods: {
		skip(item) {
			if (item.isClick) {
				const handLink = this.$router.resolve({
					path: '/order/list',
					query: {
						from_time: this.params.from_time,
						to_time: this.params.to_time,
						order_status: item.order_status,
					},
				});
				window.open(handLink.href, '_blank');
			}
		},
	},
};
</script>

<style lang="less" scoped>
.data-view {
	display: flex;
	margin-top: 24px;
	padding-left: 16px;
	padding-right: 8px;
	.item {
		display: flex;
		flex-direction: column;
		flex: 1;
		&:nth-child(n + 2) {
			margin-left: 35px;
		}
		.num {
			font-size: 24px;
			color: #333;
			font-weight: bold;
			line-height: 36px;
			font-family: DINPro-Bold, DINPro;
			.flag {
				font-size: 14px;
				margin-right: 2px;
			}
		}
		.text {
			font-size: 14px;
			line-height: 20px;
			color: #999;
			margin-top: 4px;
			margin-bottom: 6px;
			display: flex;
			align-items: center;
		}
	}
	.click:hover {
		cursor: pointer;
		.num {
			color: @color-primary;
		}
		.text {
			color: @color-primary;
		}
	}
}
</style>
